import React, { useEffect } from 'react';
import '../../shared/styles/our-purpose.css';
import { PurposeAccordion } from '../../shared/components/PurposeAccordion';
import { SEO } from '../../shared/components/SEO';

export default function ForOurPeople() {
  useEffect(() => {
    document.body.classList.add('loaded');
    document.body.classList.add('zfast-theme-page');
    return () => {
      document.body.classList.remove('loaded');
      document.body.classList.remove('zfast-theme-page');
    };
  }, []);

  return (
    <>
      <SEO 
        title="For Our People | ZFAST Agritech India" 
        description="Learn how ZFAST Agritech India invests in our people, promoting equal opportunities, good work conditions, safety, and community development." 
        path="/for-our-people" 
      />
      <div className="zfast-clone-wrapper zfast-theme-page" dangerouslySetInnerHTML={{ __html: `
<div data-barba="container">
<header class="header--medium">
<div class="header-background background--image">
<img alt="ZFAST agritech team members" class="header-background__image" loading="eager" width="1920" height="600" src="/images/about/zfast-agritech-team.webp"/>
<div class="show-overlay"></div>

<a class="link link--overlay" href="#content" target="_self"></a>
</div>
<div class="header-text">
<div class="container">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="header-text-titles">
<h1>for our people</h1>
</div>
</div>
</div>
</div>
</header>
<section class="content-wrapper" id="content" role="main">
<div class="content-wrapper">
<article class="post-type-page" id="post-452">
<section class="article-content">
<div class="article-body">
<section class="block__body-text color__black background__grey block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
</div>
<div class="col-12 col-lg-8 order-3 order-lg-2">
<div class="content">
<p class="~a7" id="+a7*c724[a0*b14[a0*]b38]c754[a7*b14[a0*]b39[a2*]b25[a7*]b24]c134|x0">People have always been at the heart of the ZFAST story, a fact reflected in our purpose: <em class="~a8" id="a8*c724[a0*b14[a0*]b38]c754[a7*b14[a0*]b39[a2*]b25[a7*]b24]c141[a8*b14[a0*]b39[a2*]b25[a7*]b25[a8*]b24]c299|x0">“Courage to care for generations to come”</em>.</p>
<p class="~a9" id="+a9*c724[a0*b14[a0*]b38]c754[a9*b14[a0*]b39[a2*]b25[a9*]b24]c134|x0">Our values,  promote ongoing, inclusive and sustainable economic growth; full and productive employment; and decent work for all. We aim to develop a highly engaged workforce that reflects the makeup of the societies in which we operate, believing that diverse and inclusive teams better understand and reflect customers and stakeholders; enhance business performance; and work more creatively and innovatively.</p>
</div>
</div>
<div class="col-12 col-lg-4 order-1 order-lg-3">
<div class="container d-flex logo-container">
<img alt="ZFAST purpose people icon" decoding="async" loading="lazy" width="1024" height="1024" src="/images/home/zfast-cattle-feed-premium.webp"/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${"/images/about/zfast-equal-opportunities.webp"});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">1</span></div>
<h2 class="block__image-number--title">Equal opportunities</h2>
<p class="block__image-number--content">Aiming to build and develop a future proof and diverse inclusive workforce.</p>
</div>
</div>
</div>
</div>
</div>
</section>


<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
<div class="content">
<p class="~a10" id="+a10*c724[a0*b14[a0*]b38]c754[a10*b14[a0*]b39[a2*]b25[a10*]b24]c134|x0">At ZFAST Agritech India, we prioritize the physical and mental well-being of our workforce across all manufacturing facilities and agricultural operations. By implementing rigorous safety standards, providing continuous occupational health training, and maintaining an open-door policy for worker feedback, we foster an environment where every employee feels secure and valued.</p>
<p>Our proactive approach to workplace safety not only prevents incidents but also boosts morale and productivity, ensuring that our team can continue delivering the highest quality nutrition and agritech products without ever compromising their health.</p>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__image-number block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-no block-padding-left-no block-padding-right-no block-padding-bottom-no">
<div class="container-fluid block__image-number--container-outer" style="background-image: url(${"/images/about/zfast-community-development.webp"});">
<div class="container">
<div class="row">
<div class="col-12 col-md-6 col-xl-5 offset-md-6 offset-xl-7">
<div class="block__image-number--container-inner">
<div class="block__image-number--counter"><span class="block__image-number--number">2</span></div>
<h2 class="block__image-number--title">Community Development</h2>
<p class="block__image-number--content">To drive sustainable development around us through education and knowledge. </p>
</div>
</div>
</div>
</div>
</div>
</section>
<section class="block__body-text color__black background__white block-margin-top-no block-margin-left-no block-margin-right-no block-margin-bottom-no block-padding-top-large block-padding-left-no block-padding-right-no block-padding-bottom-large" style="">
<div class="container">
<div class="row">
<div class="col-12 col-lg-8 offset-lg-2">
<div class="row order-1 order-lg-2">
<div class="col-12">
<div class="head">
<h2>Extended Producer Responsibility (EPR)</h2>
</div>
</div>
<div class="col-12 col-lg-8 order-3 order-lg-2">
<div class="content">
<p class="~a36">We work towards helping shape the future by driving sustainable development around us through responsible waste management and circular economy initiatives. To manage our plastic and packaging footprint is to make a long-term investment in our environment and, ultimately, in the local Indian communities where we operate.</p>
<p class="~a39">Through our internal campaign “Green India, Clean India” we commit to investing in the environment through Extended Producer Responsibility (EPR) programs.</p>
<p class="~a40">With a deep-rooted presence across India, our teams are uniquely positioned to understand the environmental challenges of our local ecosystems. By supporting plastic waste collection, farmer education on sustainable packaging, and local recycling programs, we enable communities to thrive sustainably.</p>
</div>
</div>
<div class="col-12 col-lg-4 order-1 order-lg-3">
<div class="container d-flex logo-container">
<img alt="Green India Clean India campaign logo" decoding="async" loading="lazy" width="400" height="300" src="${'/images/about/zfast-equal-opportunities.webp'}"/>
</div>
</div>
</div>
<div class="row mt-3">
<div class="col-12">
<a class="button-slide button-slide--primary" href="#" target="_self"><span>Read more on Green India, Clean India</span></a>
</div>
</div>
</div>
</div>
</div>
</section>

</div>
</section>
</article>
</div><!-- /content-wrapper -->
</section>

</div>
` }} />
      <PurposeAccordion />
    </>
  );
}
